import SmartInventory from "./SmartInventory";

export default SmartInventory;